import { makeStyles } from '@material-ui/core';
import { hSpacing } from 'src/common/helpers/config';
import { calculateHeight, calculateWidth, rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  container: {
    height: '100%',
    marginLeft: '0vw',
    backgroundColor: themeColor.lightBackground,
    fontFamily: 'Roboto',
    fontStretch: 'normal',
    fontStyle: 'normal',
    outline: 'none',
  },
  header: {
    width: '100%',
    height: '10vh',
    backgroundColor: themeColor.white,
    paddingTop: '3.5vh',
    paddingLeft: '2vw',
    fontSize: vh(2.604),
    fontWeight: 500,
    letterSpacing: '0.02vw',
    color: theme.palette.primary.main,
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 'unset',
      height: '8.698vh',
      width: hSpacing,
      background: theme?.configColors?.secondaryColor || theme.palette.secondary.main,
    },
  },
  actionContainer: {
    height: '80vh',
    width: '100%',
    paddingLeft: '1.31vw',
    paddingTop: '1.43vh',
    paddingRight: '1.757vw',
  },
  command: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '10vw',
    marginRight: calculateWidth(10).stringValue,
    marginBottom: calculateHeight(10).stringValue,
  },
  commandSmallForm: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '15.14vw',
    marginRight: calculateWidth(10).stringValue,
    marginBottom: calculateWidth(10).stringValue,
  },
  subCategory: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    marginRight: calculateWidth(10).stringValue,
    marginBottom: calculateHeight(10).stringValue,
  },
  hideButtonLabel: {
    fontSize: vh(2.34),
    fontWeight: 500,
    letterSpacing: '0.5px',
    textAlign: 'center',
    color: themeColor.white,
    textTransform: 'uppercase',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '10vh',
    width: '100%',
    paddingRight: '1.757vw',
  },
  subGroupName: {
    width: 'auto',
    fontWeight: 500,
    fontSize: rem(1),
    marginTop: calculateHeight(10).stringValue,
    marginBottom: calculateHeight(8).stringValue,
    paddingBottom: calculateHeight(10).stringValue,
    borderBottom: '1px solid lightgray',
  },
}));
